import {RSAA} from "redux-api-middleware";
import { withAuth } from '../reducers'

import {URL_API,TICKETSEND_REQUEST,TICKETSEND_SUCCESS,TICKETSEND_FAILURE} from "../constants";

export const addTicket = (jData) => ({
  [RSAA]: {
    endpoint: `${URL_API}/request/`,
    method: 'POST',
    body: JSON.stringify(jData),
    headers: withAuth({ 'Content-Type': 'application/json' }),
    types: [
      TICKETSEND_REQUEST, TICKETSEND_SUCCESS, TICKETSEND_FAILURE
    ]
  }
})


// WEBPACK FOOTER //
// ./src/actions/addNewTicket.js